module.exports = __webpack_public_path__ + "img/tu2.0b4a91ad.png";